import { render, staticRenderFns } from "./cobertura_deducible.vue?vue&type=template&id=13ec2924"
import script from "./cobertura_deducible.vue?vue&type=script&lang=js"
export * from "./cobertura_deducible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports